const Clay = require('json-clay')

module.exports = new Clay({
  schema: require('./schema')
})

module.exports.batchIdPattern = require('./schema.js').properties._id.pattern
